import PropTypes from 'prop-types'
import { X } from 'lucide-react'
import clsx from 'clsx'

/**
 * Modal Component
 * Reusable modal wrapper with overlay, header, body, and footer
 */
export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  actions,
  size = 'md',
}) {
  if (!isOpen) return null

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className={clsx('relative bg-white rounded-lg shadow-lg w-full mx-4', sizeClasses[size])}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-pawssible-slate-200">
          <h2 className="text-lg font-semibold text-pawssible-slate-900">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-pawssible-slate-100 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">{children}</div>

        {/* Footer Actions */}
        {actions && (
          <div className="flex items-center justify-end gap-3 p-6 border-t border-pawssible-slate-200">
            {actions}
          </div>
        )}
      </div>
    </div>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
}
